import { IMPORT_METHODS } from '@/components/DataIngestion/_constants/data-ingestion';
import { Button, FieldError, SelectInput } from '@payloadcms/ui';
import { useState } from 'react';

interface ImportMethodSelectorProps {
  setValidImportMethod: (importMethod: string) => void;
}

const ImportMethodSelector = ({ setValidImportMethod }: ImportMethodSelectorProps) => {
  const [importMethod, setImportMethod] = useState<string>('');
  const [importSourceError, setImportSourceError] = useState<boolean>(false);

  const IMPORT_METHOD_OPTIONS = [
    {
      label: 'From an export',
      value: IMPORT_METHODS.FROM_EXPORT,
    },
  ];

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (!importMethod) {
      setImportSourceError(true);
      return;
    }

    setImportSourceError(false);
    setValidImportMethod(importMethod);
  };

  return (
    <div>
      <h2>Choose an import method</h2>
      <form onSubmit={handleSubmit}>
        <SelectInput
          name="importMethod"
          value={importMethod}
          path="importMethod"
          onChange={(options) => {
            if (options && 'value' in options) {
              setImportMethod(options.value as string);
            }
          }}
          label="Import method"
          description="Where would you like to import the data from?"
          options={IMPORT_METHOD_OPTIONS}
          required={true}
          Error={<FieldError path="importMethod" message="Import method is required" showError={importSourceError} />}
        />
        <Button type="submit" buttonStyle="primary">
          Continue
        </Button>
      </form>
    </div>
  );
};

export default ImportMethodSelector;
